<ew-mat-dialog-custom ngClass="overflow-hidden">
  <main class="custom-spread-dialog mx-10 mt-8">
    <mat-spinner *ngIf="isLoading" [diameter]="50" />

    <div *ngIf="!isLoading">
      <div
        *ngIf="modalStep === 'TERMS_AND_CONDITIONS'"
        class="flex flex-col mt-4 overflow-hidden h-[460px]"
      >
        <p class="text-2xl text-black font-medium mb-4">
          {{ 'settingsCustomSpread:howItWorks' | translate }}
        </p>

        <p class="text mb-4">{{ 'settingsCustomSpread:customSpreadExplanation' | translate }}</p>
        <p class="text mb-4">{{ 'settingsCustomSpread:depositExplanation' | translate }}</p>

        <div class="text">
          <mat-checkbox [(ngModel)]="termsAccepted">
            <p class="text text-xs mt-4">
              {{ 'settingsCustomSpread:acceptTerms' | translate }}
              {{ 'settingsCustomSpread:termsAndConditionsLink' | translate }}
            </p>
          </mat-checkbox>
        </div>

        <div class="bg-gray-50 p-4 rounded-lg mb-4">
          <div class="flex items-start">
            <span class="text-amber-500 mr-2">💡</span>
            <div>
              <p class="text-base font-medium mb-2">{{ 'settingsCustomSpread:whyThisMatters' | translate }}</p>
              <p class="text text-xs">{{ 'settingsCustomSpread:benefitsExplanation' | translate }}</p>
            </div>
          </div>
        </div>
      </div>

      <div
        *ngIf="!isLoading && modalStep === 'CUSTOM_SPREAD'"
        class="flex flex-col mt-4 h-[460px] overflow-y-auto"
      >
        <p class="text-2xl text-black font-medium mb-4">
          {{ 'settingsCustomSpread:setYourSpread' | translate }}
        </p>

        <div class="flex flex-col max-h-[320px] overflow-y-auto pr-2">
          <form [formGroup]="spreadsForm">
            <div formArrayName="spreads">
              <div *ngFor="let spread of spreadsArray.controls; let i = index" [formGroupName]="i">
                <div class="currency-row flex items-center justify-between border border-gray-200 rounded px-2 py-[6px] mb-2">
                  <div class="currency-flag flex-shrink-0 mr-4">
                    <img [src]="'https://flagcdn.com/' + (spread.get('currency')?.value | currencyCountry) + '.svg'"
                        [alt]="spread.get('currency')?.value"
                        class="w-8 h-8 rounded-full object-cover border border-gray-200">
                  </div>

                  <div class="currency-info flex-grow mr-4">
                    <div class="currency-code font-medium text-sm">
                      {{ spread.get('currency')?.value }}
                      {{ 'currencyName:' + spread.get('currency')?.value | translate }}
                    </div>
                  </div>

                  <div class="border-l border-gray-200 h-10 mx-4"></div>

                  <div class="percentage-input flex-shrink-0 w-32">
                    <div class="relative">
                      <input
                        id="spread-{{i}}"
                        type="number"
                        required
                        formControlName="spread"
                        step="0.01"
                        min="{{minSpread}}"
                        max="{{maxSpread}}"
                        class="w-full px-3 py-1.5 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm pr-6"
                        placeholder="0.00">
                      <span class="absolute inset-y-0 right-0 flex items-center pr-2 text-gray-500 text-sm">%</span>
                      <div *ngIf="spread.get('spread')?.invalid && (spread.get('spread')?.dirty || spread.get('spread')?.touched)" class="text-red-500 text-xs mt-1">
                        <div *ngIf="spread.get('spread')?.errors?.['required']">
                          {{ 'shared:required' | translate }}
                        </div>
                        <div *ngIf="spread.get('spread')?.errors?.['min']">
                          {{ 'settingsCustomSpread:spreadMinValue' | translate }}
                        </div>
                        <div *ngIf="spread.get('spread')?.errors?.['max']">
                          {{ 'settingsCustomSpread:spreadMaxValue' | translate }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="spreadsArray.length === 0 && !isLoading" class="text-center text-gray-500 py-4">
                {{ 'settingsCustomSpread:noSpreadsFound' | translate }}
              </div>
            </div>
          </form>
        </div>

        <div *ngIf="spreadsArray.length > 0 && isEditing" class="bg-orange-200 border-orange-300 mt-4 p-4 bg-amber-100 border border-amber-300 rounded-md flex items-start">
          <mat-icon class="text-amber-500 mr-2">warning</mat-icon>
          <div>
            <p class="text-sm">{{ 'settingsCustomSpread:warningMessageSpreadChangeImpact' | translate }}</p>
          </div>
        </div>

        <div *ngIf="spreadsArray.length > 0 && !isEditing" class="bg-blue-200 border-blue-300 mt-4 p-4 bg-amber-100 border border-amber-300 rounded-md flex items-start">
          <mat-icon class="text-amber-500 mr-2">info</mat-icon>
          <div>
            <p class="font-medium">{{ 'settingsCustomSpread:infoMessageAllowSetProfitMarging' | translate }}</p>
            <p class="text-sm">{{ 'settingsCustomSpread:warningMessageSpreadAddedHereWillBeApplied' | translate }}</p>
          </div>
        </div>
      </div>
    </div>

    <hr class="my-4" *ngIf="!isLoading" />
    <div class="flex justify-end gap-4" *ngIf="!isLoading">
      <button
        mat-stroked-button
        class="rounded-lg xs:w-full w-20"
        color="secondary"
        (click)="dialogRef.close()">
        {{ 'shared:cancel' | translate }}
      </button>

      <button
        mat-flat-button
        class="rounded-lg xs:w-full w-40"
        color="primary"
        [disabled]="isConfirmButtonDisabled()"
        (click)="handleClickConfirm()"
      >
        <span *ngIf="!isProcessing">
          {{ (modalStep === 'CUSTOM_SPREAD' ? 'shared:save' : 'shared:next') | translate }}
        </span>
        <mat-spinner *ngIf="isProcessing" [diameter]="20" />
      </button>
    </div>
  </main>
</ew-mat-dialog-custom>
